import { datadogRum } from '@datadog/browser-rum';

export type DDSetupOptions = {
  applicationId?: string;
  clientToken?: string;
  environment: string;
  service: string;
  sampleRate?: number;
  version?: string;
};

const IGNORED_ERROR_MESSAGES = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
];

const setup = ({
  applicationId,
  clientToken,
  environment,
  service,
  sampleRate = 10,
  version = '0',
}: DDSetupOptions) => {
  if (applicationId && clientToken) {
    datadogRum.init({
      applicationId,
      clientToken,
      site: 'datadoghq.eu',
      service,
      env: environment,
      version,
      sessionSampleRate: sampleRate,
      sessionReplaySampleRate: 0, // 0 for no session recordings
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      beforeSend: (event) => {
        if (event.type === 'error') {
          const message = event.error?.message ?? '';
          if (IGNORED_ERROR_MESSAGES.some((ignored) => message.includes(ignored))) {
            return false;
          }
        }
        return true;
      },
    });

    // Needed for Browser RUM data collecting also.
    datadogRum.startSessionReplayRecording();
    console.debug('Datadog started!');
  }
};

export default setup;
